"use client";

import { PromoCardVertical as PromoCardVerticalCore } from "@jti/core-components/components/PromoCardVertical";

import type { promoCardVerticalInputs } from "./PromoCardVertical.builder";

type PromoCardVerticalProps = BuilderComponentProps<typeof promoCardVerticalInputs>;

export const PromoCardVertical = ({
  imageUrl,
  tabletImageUrl,
  desktopImageUrl,
  title,
  imageAlt,
  dominantColor,
  tabletDominantColor,
  desktopDominantColor,
  url,
}: PromoCardVerticalProps) => {
  return (
    <PromoCardVerticalCore
      imageSrc={imageUrl}
      imageSrcTablet={tabletImageUrl}
      imageSrcDesktop={desktopImageUrl}
      imageAlt={imageAlt}
      title={title}
      href={url}
      contentBackgroundColor={dominantColor}
      contentBackgroundColorTablet={tabletDominantColor}
      contentBackgroundColorDesktop={desktopDominantColor}
    />
  );
};
